// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 279 ? "6c44d60f" : chunkId) + "." + {"229":"19dc7b57d64462da","279":"fd1e8b8369863a4d","394":"9732ebdaa4c01e95"}[chunkId] + ".js";
};